// Whole Component Tejashwini
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ component: Component, isAuthenticated, ...rest }) => {
  // Check if the user is authenticated by calling the function
  if (isAuthenticated()) {
    console.log("Authentication successful in ProtectedRoute");
    // If authenticated, return the component with the provided props
    return <Component {...rest} />;
  } else {
    console.log("Authentication failed in ProtectedRoute");
    // If not authenticated, redirect to the sign-in page
    return <Navigate to="/signin" replace />;
  }
};

export default ProtectedRoute;